export default "__VITE_PUBLIC_ASSET__58dcd410__"